import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
    data: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    dataCrud(state) {
      return state.dataCrud;
    },
    data(state) {
      return state.data;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertDataCrud(state, dataCrud) {
      state.dataCrud = dataCrud;
    },
    saveData(state, data) {
      state.status = 'success';
      state.data = data;
    },
    SET_DATA_CRUD(state, payload) {
      state.dataCrud = payload;
    },
    saveError(state) {
      state.status = 'error';
    },
    removeData(state, data) {
      state.status = 'removed';
      state.data = data;
    },
    removeError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proProfileCSchema();
        const schema = res.data;

        const resCat1 = await apiClient.catThemes();
        const catThemes = resCat1.data.data;

        const resCat2 = await apiClient.catThemesAges();
        const catThemesAges = resCat2.data.data;

        const resCat3 = await apiClient.catIntensity();
        const catIntensity = resCat3.data.data;

        schema.formCrud.themes_themes_id.items = catThemes;
        schema.formCrud.themes_ages_themes_ages_id.items = catThemesAges;
        schema.formCrud.themes_specialty_level.items = catIntensity;
        schema.formCrud.themes_experience_level.items = catIntensity;

        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadDataCrud({ commit }) {
      try {
        const id = getInstProfesId();
        const res = await apiClient.modelProProfileC(id);
        const dataCrudPre = res.data.data;

        for (let i = 0; i < dataCrudPre.length; i++) {
          const themesAges = dataCrudPre[i].themes_ages_themes_ages_id;
          dataCrudPre[i].themes_ages_themes_ages_id = themesAges.map((a) => a.themes_ages);
        }
        const dataCrud = dataCrudPre;
        commit('insertDataCrud', dataCrud);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async save({ commit }, model) {
      try {
        const id = getInstProfesId();
        const res = await apiClient.createProProfileC(id, model);
        let data = {};
        data.statusText = res.statusText;
        commit('saveData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error guardando');
        commit('saveError');
        throw error;
      }
    },
    async remove({ commit }, id) {
      try {
        let data = {};
        if (id > 0) {
          const res = await apiClient.deleteProProfileC(id);
          const status = res.status;

          if (status === 204) {
            data = res.data;
          }
        }
        commit('removeData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error removiendo');
        commit('removeError');
        throw error;
      }
    },
  },
};
